<template>
  <div class="booking-manifest-goods-info" style="display:flex;flex-direction:column">
    <div class=" operations">
      <div class="triggers">
        <div>
          <el-button :disabled="canEdit" type="primary" @click="showEditDialog(true)">{{ $t('Payment.new') }}</el-button>
          <el-button v-if="isSeaHouseChannel" :disabled="canEdit" type="primary" @click="copy">{{ $t('CargoMsg.Cargo_Copy') }}</el-button>
          <el-button :disabled="canEdit" type="primary" @click="showEditDialog(false)">{{ $t('Payment.edit2') }}</el-button>
          <el-button :disabled="canEdit" type="danger" @click="remove">{{ $t('FileHistory.Delete') }}</el-button>
          <el-button
            v-show="!lclView"
            :disabled="canEdit"
            type="primary"
            @click="importFromContainer"
          >{{ $t('SeaExport.GetPackingInformation') }}</el-button>
          <el-button
            v-show="job.uuid&&job.lclMasterUuid"
            :disabled="innerIsEditing"
            type="primary"
            @click="importFromLcLContainer"
          >{{ $t('SeaExport.SynchronizeMainTicketPackingInformation') }}</el-button>

          <!--主票导入货物明细 这个查过代码没用了 lclView = false 不显示的-->
          <el-upload
            v-show="lclView"
            :disabled="!innerIsEditing"
            :action="URL.seaExport.manifestImportExcelLcl"
            :headers="{sessionId: $store.getters.userInfo.sessionId}"
            :show-file-list="false"
            accept=".xls, .xlsx"
            :before-upload="beforeUpload"
            :on-success="uploadSuccess"
            style="display: inline-block;padding-left: 5px;"
          >
            <el-button v-show="lclView" slot="trigger" :disabled="!innerIsEditing" type="primary">{{ $t('SeaExport.ExcelImport') }}</el-button>
          </el-upload>
          <el-button
            v-show="manifestInfo.uuid"
            no="cfmConfirm"
            :disabled="isEdit"
            type="primary"
            @click="cfmBtnClickHandlers"
          >{{ $t('SeaExport.Confirm') }}
          </el-button>
          <el-button
            v-show="manifestInfo.uuid"
            no="SynchronizePackingInfo"
            :disabled="isEdit"
            type="primary"
            @click="synchronizePackingInfo"
          >{{ $t('SeaExport.SynchronizePackingInfo') }}</el-button>
        </div>
      </div>
    </div>
    <cargo-ag-grid
      :grid-options="gridOptions"
      :column-defs="columnDefs"
      :row-data="finalRowData"
      style="width:100%;height:200px;margin-top:5px"
      @gridReady="onGridReady"
    />
    <!-- 编辑弹窗 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="editDialog.visible"
      :title="editDialog.title"
      width="400px"
      :close-on-click-modal="false"
    >
      <div class="app-main-inner-row" style="padding-bottom: 10px;">
        <el-form label-width="110px" label-position="left">
          <el-form-item v-if="!isAddSpelling" :label="$t('SeaExport.SoNo')">
            <el-input v-model="editDialog.form.soNo" :disabled="!isEditing" />
          </el-form-item>
          <el-form-item :label="$t('Payment.containerNo')">
            <el-input v-model="editDialog.form.containerNo" :disabled="!isEditing" @change="editDialog.form.containerNo=toUpperCaseTrim(editDialog.form.containerNo)" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.SealNo')">
            <el-input v-model="editDialog.form.sealNo" :disabled="!isEditing" @change="editDialog.form.sealNo=toUpperCaseTrim(editDialog.form.sealNo)" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.ContainerSize')">
            <el-input v-model="editDialog.form.eqSize" :disabled="!isEditing" />
          </el-form-item>
          <el-form-item :label="$t('queryJob.englishDescriptionOfGoods')">
            <el-input :disabled="true" :value="editDialog.form.cargoEnglishName">
              <i
                slot="suffix"
                :class="isEditing?'el-input__icon el-icon-edit':'el-input__icon el-icon-search'"
                style="font-size: 12px;cursor: pointer;color: black;"
                @click="showAdvanceTextDialog($t('queryJob.englishDescriptionOfGoods'),editDialog.form.cargoEnglishName,val=>{editDialog.form.cargoEnglishName=val})"
              />
            </el-input>
          </el-form-item>
          <el-form-item :label="$t('SeaExport.Marks')">
            <el-input :disabled="true" :value="editDialog.form.mark">
              <i
                slot="suffix"
                :class="isEditing?'el-input__icon el-icon-edit':'el-input__icon el-icon-search'"
                style="font-size: 12px;cursor: pointer;color: black;"
                @click="showAdvanceTextDialog($t('SeaExport.Marks'),editDialog.form.mark,val=>{editDialog.form.mark=val})"
              />
            </el-input>
          </el-form-item>
          <el-form-item label="HSCode">
            <el-input :disabled="true" :value="editDialog.form.hsCode">
              <i
                slot="suffix"
                :class="isEditing?'el-input__icon el-icon-edit':'el-input__icon el-icon-search'"
                style="font-size: 12px;cursor: pointer;color: black;"
                @click="showAdvanceTextDialog('HSCode',editDialog.form.hsCode,val=>{editDialog.form.hsCode=val})"
              />
            </el-input>
          </el-form-item>
          <el-form-item :label="$t('SeaExport.Package')">
            <el-input v-model="editDialog.form.packing" :disabled="!isEditing" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.Quantity')">
            <el-input-number
              v-model="editDialog.form.quantity"
              :min="0"
              :disabled="!isEditing"
              :controls="false"
              style="width:100%"
            />
          </el-form-item>
          <el-form-item v-if="isSeaHouseChannel" :label="$t('SeaExport.Weight')">
            <el-input-number
              v-model="editDialog.form.weight"
              :min="0"
              :disabled="!isEditing"
              :controls="false"
              :precision="3"
              style="width:100%"
              @blur="editDialog.form.weight=roundHalfUp(editDialog.form.weight,3)"
            />
          </el-form-item>
          <el-form-item v-else :label="$t('SeaExport.Weight')">
            <el-input-number
              v-model="editDialog.form.weight"
              :min="0"
              :disabled="!isEditing"
              :controls="false"
              :precision="3"
              style="width:70%"
              @blur="editDialog.form.weight=roundHalfUp(editDialog.form.weight,3)"
            />
            <el-select v-model="editDialog.form.weightUnit" style="width:30%">
              <el-option
                v-for="item in WEIGHT_UNIT"
                :key="item.code"
                :label="item.code"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
          <el-form-item v-if="isSeaHouseChannel" :label="$t('SeaExport.Cubage')">
            <el-input-number
              v-model="editDialog.form.cubage"
              :min="0"
              :disabled="!isEditing"
              :controls="false"
              :precision="3"
              style="width:100%"
              @blur="editDialog.form.cubage=roundHalfUp(editDialog.form.cubage,3)"
            />
          </el-form-item>
          <el-form-item v-else :label="$t('SeaExport.Cubage')">
            <el-input-number
              v-model="editDialog.form.cubage"
              :min="0"
              :disabled="!isEditing"
              :controls="false"
              :precision="3"
              style="width:70%"
              @blur="editDialog.form.cubage=roundHalfUp(editDialog.form.cubage,3)"
            />
            <el-select v-model="editDialog.form.cubageUnit" style="width:30%">
              <el-option
                v-for="item in CUBAGE_UNIT"
                :key="item.code"
                :label="item.code"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_Remark')">
            <el-input :disabled="true" :value="editDialog.form.goodsRemark">
              <i
                slot="suffix"
                :class="isEditing?'el-input__icon el-icon-edit':'el-input__icon el-icon-search'"
                style="font-size: 12px;cursor: pointer;color: black;"
                @click="showAdvanceTextDialog($t('CargoMsg.Cargo_Remark'),editDialog.form.goodsRemark,val=>{checkGoodsRemark(val)})"
              />
            </el-input>
          </el-form-item>
          <el-form-item label="UN Code">
            <el-input v-model="editDialog.form.danUNNo" :disabled="!isEditing" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.DangerousClass')">
            <el-input v-model="editDialog.form.danClassNo" :disabled="!isEditing" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.PrimaryCustomsNo')">
            <el-checkbox v-model="editDialog.form.masterSoNo" :disabled="!isEditing" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.DangerousGoodsContact')">
            <el-input v-model="editDialog.form.dngrContactUser" :disabled="!isEditing" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.DangerousGoodsContactPhoneNumber')">
            <el-input v-model="editDialog.form.dngrContactNumber" :disabled="!isEditing" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.ediStatus')">
            <el-input :disabled="true" :value="editDialog.title === $t('common.btn.new') ? $t('SeaExport.notSend') : ColumnUtils.ediStateFunction(editDialog.form.ediStatus)" />
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer">
        <el-button v-show="innerIsEditing" type="primary" @click="save">{{ $t('common.btn.save') }}</el-button>
        <el-button @click="editDialog.visible=false">{{ innerIsEditing?$t('common.btn.cancel'):$t('common.btn.close') }}</el-button>
      </span>
    </el-dialog>
    <!-- 高级文本弹框 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="advanceTextDialog.visible"
      :title="advanceTextDialog.title"
      width="600px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-input v-model="advanceTextDialog.value" :disabled="!isEditing" type="textarea" rows="10" />
      <span slot="footer">
        <el-button v-show="isEditing" type="primary" @click="finishAdvanceText">{{ $t('common.btn.confirm') }}</el-button>
        <el-button
          @click="advanceTextDialog.visible=false"
        >{{ $t('common.btn.close') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { ErrorTip } from '@/utils/class/ErrorTip'
import { roundHalfUp } from '@/utils/NumberUtils'
import ContainerNoHelper from '@/utils/containerNoHelper'
import ColumnUtils from '@/utils/ColumnUtils'
import { AutoIncrementNum } from '@/utils/commonUtil'
import { SeaExportJob } from '@/class/model/booking/SeaExportJob'
import { ManifestInfo } from '@/class/model/booking/ManifestInfo'
import { ManifestGoodsInfo } from '@/class/model/booking/ManifestGoodsInfo'
import URL from '@/api/urlTranslator'
import { deepClone } from '@/utils'
import { PrePlanBookingUtil } from '@/class/cargo/model/utils/PrePlanBookingUtil'
import { isNumber } from '@/utils/validate'
import StrUtils from '@/utils/StrUtils'
import { getHeaderComponentParamsWithWarning } from '@/utils/agGrid'
import { WEIGHT_UNIT, CUBAGE_UNIT } from '@/class/cargo/model/parameters/SeaExportConstants'
import * as RateUtil from '@/class/cargo/model/utils/RateUtil'
import { ManifestCfmState } from '@/class/cargo/model/parameters/ManifestCfmState'
import { confirmManifest, synchronousManifest } from '@/api/seaExport/manifestInfo'
import { getLoading } from '@/utils/utilBaseElement'
import * as commonUtil from '@/utils/commonUtil'
import * as CommonState from '@/class/cargo/model/parameters/CommonState'

export default {
  name: 'BookingManifestGoodsInfoJc',
  props: {
    job: { type: Object, required: true },
    manifestInfo: { type: Object, required: true },
    isEdit: { type: Boolean, required: true },
    isEditing: { type: Boolean, required: true },
    lclView: { type: Boolean, default: false },
    isOrNotDisplaySoNo: { type: Boolean, default: false },
    isAddSpelling: { type: Boolean, default: false },
    isSeaHouseChannel: { type: Boolean, default: false },
    showCombinedManifest: { type: Boolean, default: false },
    specialCharacterCheck: { type: Boolean, default: false }
  },
  data() {
    return {
      ManifestCfmState,
      URL,
      roundHalfUp,
      ColumnUtils,
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        // 选中 勾选框或者其他列 都会触发
        onCellFocused: (event) => {
          this.onGridCellFocused(event)
        },
        // 选中 勾选框触发
        onRowSelected: (event) => {
          this.onGridRowSelected(event)
        },
        onRowClicked: this.onRowClicked,
        context: {
          componentParent: this
        }
      },
      rowData: [],
      gridApi: null,
      selectedRow: null,
      cargoEnglishNameCheck: null,
      markCheck: null,
      autoIncrementNum: new AutoIncrementNum(),
      containerNoClass: '',
      editDialog: {
        visible: false,
        title: '',
        form: new ManifestGoodsInfo().fillDefaultValue().getData()
      },
      advanceTextDialog: {
        visible: false,
        title: '',
        value: '',
        successCallback: null
      },
      WEIGHT_UNIT,
      CUBAGE_UNIT
    }
  },
  computed: {
    innerIsEditing() {
      return this.isEditing && Boolean(this.manifestInfo.uuid)
    },
    canEdit() {
      const isSent = PrePlanBookingUtil.isSent(this.manifestInfo)
      return ((!this.innerIsEditing || Boolean(this.isSeaHouseChannel && isSent)) && this.manifestInfo.todo !== 'new')
    },
    columnDefs() {
      let columnDefs
      if (this.isSeaHouseChannel) {
        columnDefs = [
          {
            headerName: '',
            field: '',
            width: 65,
            headerCheckboxSelection: true,
            checkboxSelection: true,
            sortable: false,
            suppressMenu: true,
            suppressSizeToFit: true,
            resizable: false
          },
          {
            headerName: this.$t('SeaExport.SoNo'),
            headerClass: () => {
              return this.isSeaHouseChannel ? 'required-label' : ''
            },
            colId: 'soNo',
            field: 'soNo',
            width: 100,
            hide: this.isAddSpelling,
            editable: !(this.isSeaHouseChannel && this.manifestInfo.manifestId)
          }, {
            headerName: this.$t('Payment.containerNo'),
            headerClass: () => {
              return this.isSeaHouseChannel ? 'required-label' : ''
            },
            colId: 'containerNo',
            field: 'containerNo',
            width: 100,
            editable: !(this.isSeaHouseChannel && this.manifestInfo.manifestId),
            cellStyle: (params) => {
              return this.containerNbrStyleFunction(params.data)
            }
          }, {
            headerName: this.$t('SeaExport.SealNo'),
            headerClass: () => {
              return this.isSeaHouseChannel ? 'required-label' : ''
            },
            colId: 'sealNo',
            field: 'sealNo',
            width: 100,
            editable: !(this.isSeaHouseChannel && this.manifestInfo.manifestId)
          }, {
            headerName: this.$t('SeaExport.ContainerSize'),
            headerClass: () => {
              return this.isSeaHouseChannel ? 'required-label' : ''
            },
            colId: 'eqSize',
            field: 'eqSize',
            width: 100
          }, {
            headerName: this.$t('queryJob.englishDescriptionOfGoods'),
            headerClass: () => {
              return this.isSeaHouseChannel ? 'required-label' : ''
            },
            colId: 'cargoEnglishName',
            field: 'cargoEnglishName',
            width: 100,
            headerComponentParams: this.cargoEnglishNameCheck
          }, {
            headerName: this.$t('SeaExport.Marks'),
            headerClass: () => {
              return this.isSeaHouseChannel ? 'required-label' : ''
            },
            colId: 'mark',
            field: 'mark',
            width: 100,
            headerComponentParams: this.markCheck
          }, {
            headerName: 'HSCode',
            colId: 'hsCode',
            field: 'hsCode',
            width: 100,
            cellStyle: (params) => {
              return this.hsCodeNbrStyleFunction(params.data)
            }
          }, {
            headerName: this.$t('SeaExport.Package'),
            headerClass: () => {
              return this.isSeaHouseChannel ? 'required-label' : ''
            },
            colId: 'packing',
            field: 'packing',
            width: 100
          }, {
            headerName: this.$t('SeaExport.Quantity'),
            headerClass: () => {
              return this.isSeaHouseChannel ? 'required-label' : ''
            },
            colId: 'quantity',
            field: 'quantity',
            width: 100
          }, {
            headerName: this.$t('SeaExport.Weight'),
            headerClass: () => {
              return this.isSeaHouseChannel ? 'required-label' : ''
            },
            colId: 'weight',
            field: 'weight',
            width: 100,
            cellRenderer: params => {
              return (Number(params.value) || 0).toFixed(3)
            }
          }, {
            headerName: this.$t('SeaExport.Cubage'),
            headerClass: () => {
              return this.isSeaHouseChannel ? 'required-label' : ''
            },
            colId: 'cubage',
            field: 'cubage',
            width: 100,
            cellRenderer: params => {
              return (Number(params.value) || 0).toFixed(3)
            }
          }, {
            headerName: 'UN Code',
            colId: 'danUNNo',
            field: 'danUNNo',
            width: 100
          }, {
            headerName: this.$t('SeaExport.DangerousClass'),
            colId: 'danClassNo',
            field: 'danClassNo',
            width: 100
          }, {
            headerName: this.$t('SeaExport.PrimaryCustomsNo'),
            colId: 'masterSoNo',
            field: 'masterSoNo',
            cellRendererFramework: 'agGridColumnEdit',
            custom: {
              isEdit: false,
              tag: 'el-checkbox'
            },
            width: 100
          }, {
            headerName: this.$t('SeaExport.ediStatus'),
            colId: 'ediStatus',
            field: 'ediStatus',
            width: 100,
            cellRenderer: params => {
              return ColumnUtils.ediStateFunction(params.data.ediStatus)
            }
          }, {
            headerName: this.$t('FileHistory.operation'),
            colId: '_operate',
            field: '',
            width: 100,
            cellRendererFramework: 'iconDocumentCopy',
            custom: {
              isEdit: this.innerIsEditing,
              clicked: p => { this.copyAndAddItem(p) }
            }
          },
          {
            headerName: 'SOC',
            colId: 'soc',
            field: 'soc',
            suppressMenu: true,
            width: 50,
            cellRendererFramework: 'agGridColumnEdit',
            custom: {
              isEdit: false,
              tag: 'el-checkbox',
              attrs: {
                isEditCBFunc: (params) => {
                  return this.innerIsEditing
                }, trueLabel: 1, falseLabel: 0
              }
            }
          },
          {
            headerName: this.$t('SeaExport.emptyBox'),
            colId: 'emptyBox',
            field: 'emptyBox',
            suppressMenu: true,
            width: 50,
            cellRendererFramework: 'agGridColumnEdit',
            custom: {
              isEdit: false,
              tag: 'el-checkbox',
              attrs: {
                isEditCBFunc: (params) => {
                  return this.innerIsEditing
                }, trueLabel: 1, falseLabel: 0
              }
            }
          }, {
            headerName: this.$t('SeaExport.DangerousGoodsContact'),
            colId: 'dngrContactUser',
            field: 'dngrContactUser',
            width: 100,
            editable: this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor'
          }, {
            headerName: this.$t('SeaExport.DangerousGoodsContactPhoneNumber'),
            colId: 'dngrContactNumber',
            field: 'dngrContactNumber',
            width: 100,
            editable: this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor'
          }
        ]
      } else {
        columnDefs = [
          {
            headerName: '',
            field: '',
            width: 65,
            headerCheckboxSelection: true,
            checkboxSelection: true,
            sortable: false,
            suppressMenu: true,
            suppressSizeToFit: true,
            resizable: false
          },
          {
            headerName: this.$t('SeaExport.SoNo'),
            headerClass: () => {
              return this.isSeaHouseChannel ? 'required-label' : ''
            },
            colId: 'soNo',
            field: 'soNo',
            width: 100,
            hide: this.isAddSpelling
          }, {
            headerName: this.$t('Payment.containerNo'),
            headerClass: () => {
              return this.isSeaHouseChannel ? 'required-label' : ''
            },
            colId: 'containerNo',
            field: 'containerNo',
            width: 100,
            cellStyle: (params) => {
              return this.containerNbrStyleFunction(params.data)
            }
          }, {
            headerName: this.$t('SeaExport.SealNo'),
            headerClass: () => {
              return this.isSeaHouseChannel ? 'required-label' : ''
            },
            colId: 'sealNo',
            field: 'sealNo',
            width: 100
          }, {
            headerName: this.$t('SeaExport.ContainerSize'),
            headerClass: () => {
              return this.isSeaHouseChannel ? 'required-label' : ''
            },
            colId: 'eqSize',
            field: 'eqSize',
            width: 100
          }, {
            headerName: this.$t('queryJob.englishDescriptionOfGoods'),
            headerClass: () => {
              return this.isSeaHouseChannel ? 'required-label' : ''
            },
            colId: 'cargoEnglishName',
            field: 'cargoEnglishName',
            width: 100,
            headerComponentParams: this.cargoEnglishNameCheck,
            cellRenderer: params => {
              // 将换行符 \n 替换为 <br> 标签
              return params.value ? params.value.replace(/\n/g, '<br>') : ''
            },
            autoHeight: true, // 自动调整行高以显示换行内容
            wrapText: true // 允许文本换行
          }, {
            headerName: this.$t('SeaExport.Marks'),
            headerClass: () => {
              return this.isSeaHouseChannel ? 'required-label' : ''
            },
            colId: 'mark',
            field: 'mark',
            width: 100,
            headerComponentParams: this.markCheck,
            cellRenderer: params => {
              // 将换行符 \n 替换为 <br> 标签
              return params.value ? params.value.replace(/\n/g, '<br>') : ''
            },
            autoHeight: true, // 自动调整行高以显示换行内容
            wrapText: true // 允许文本换行
          }, {
            headerName: 'HSCode',
            colId: 'hsCode',
            field: 'hsCode',
            width: 100,
            cellStyle: (params) => {
              return this.hsCodeNbrStyleFunction(params.data)
            }
          }, {
            headerName: this.$t('CargoMsg.Cargo_Remark'),
            colId: 'goodsRemark',
            field: 'goodsRemark',
            width: 100,
            cellRenderer: params => {
              // 将换行符 \n 替换为 <br> 标签
              return params.value ? params.value.replace(/\n/g, '<br>') : ''
            },
            autoHeight: true, // 自动调整行高以显示换行内容
            wrapText: true // 允许文本换行
          }, {
            headerName: this.$t('SeaExport.Package'),
            headerClass: () => {
              return this.isSeaHouseChannel ? 'required-label' : ''
            },
            colId: 'packing',
            field: 'packing',
            width: 100
          }, {
            headerName: this.$t('SeaExport.Quantity'),
            headerClass: () => {
              return this.isSeaHouseChannel ? 'required-label' : ''
            },
            colId: 'quantity',
            field: 'quantity',
            width: 100
          }, {
            headerName: this.$t('SeaExport.Weight'),
            headerClass: () => {
              return this.isSeaHouseChannel ? 'required-label' : ''
            },
            colId: 'weight',
            field: 'weight',
            width: 100,
            cellRenderer: params => {
              return (Number(params.value) || 0).toFixed(3)
            }
          }, {
            headerName: this.$t('SeaExport.WeightUnit'),
            colId: 'weightUnit',
            field: 'weightUnit',
            width: 100
          }, {
            headerName: this.$t('SeaExport.Cubage'),
            headerClass: () => {
              return this.isSeaHouseChannel ? 'required-label' : ''
            },
            colId: 'cubage',
            field: 'cubage',
            width: 100,
            cellRenderer: params => {
              return (Number(params.value) || 0).toFixed(3)
            }
          }, {
            headerName: this.$t('SeaExport.CubageUnit'),
            colId: 'cubageUnit',
            field: 'cubageUnit',
            width: 100
          }, {
            headerName: 'UN Code',
            colId: 'danUNNo',
            field: 'danUNNo',
            width: 100
          }, {
            headerName: this.$t('SeaExport.DangerousClass'),
            colId: 'danClassNo',
            field: 'danClassNo',
            width: 100
          }, {
            headerName: this.$t('SeaExport.PrimaryCustomsNo'),
            colId: 'masterSoNo',
            field: 'masterSoNo',
            cellRendererFramework: 'agGridColumnEdit',
            custom: {
              isEdit: false,
              tag: 'el-checkbox'
            },
            width: 100
          }, {
            headerName: this.$t('SeaExport.ediStatus'),
            colId: 'ediStatus',
            field: 'ediStatus',
            width: 100,
            cellRenderer: params => {
              return ColumnUtils.ediStateFunction(params.data.ediStatus)
            }
          }, {
            headerName: this.$t('FileHistory.operation'),
            colId: '_operate',
            field: '',
            width: 100,
            cellRendererFramework: 'iconDocumentCopy',
            custom: {
              isEdit: this.innerIsEditing,
              clicked: p => { this.copyAndAddItem(p) }
            }
          },
          {
            headerName: 'SOC',
            colId: 'soc',
            field: 'soc',
            suppressMenu: true,
            width: 50,
            cellRendererFramework: 'agGridColumnEdit',
            custom: {
              isEdit: false,
              tag: 'el-checkbox',
              attrs: {
                isEditCBFunc: (params) => {
                  return this.innerIsEditing
                }, trueLabel: 1, falseLabel: 0
              }
            }
          },
          {
            headerName: this.$t('SeaExport.emptyBox'),
            colId: 'emptyBox',
            field: 'emptyBox',
            suppressMenu: true,
            width: 50,
            cellRendererFramework: 'agGridColumnEdit',
            custom: {
              isEdit: false,
              tag: 'el-checkbox',
              attrs: {
                isEditCBFunc: (params) => {
                  return this.innerIsEditing
                }, trueLabel: 1, falseLabel: 0
              }
            }
          }, {
            headerName: this.$t('SeaExport.DangerousGoodsContact'),
            colId: 'dngrContactUser',
            field: 'dngrContactUser',
            width: 100,
            editable: this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor'
          }, {
            headerName: this.$t('SeaExport.DangerousGoodsContactPhoneNumber'),
            colId: 'dngrContactNumber',
            field: 'dngrContactNumber',
            width: 100,
            editable: this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor'
          }, {
            headerName: this.$t('SeaExport.ManifestDeliveryStatus'),
            colId: 'seaHouseState',
            field: 'seaHouseState',
            width: 100,
            cellRenderer: params => {
              return CommonState.getNameByCode(this.sendType, params.value)
            }
          }
        ]
      }
      /* columnDefs.push({
        headerName: this.$t('SeaExport.SequenceNumber'),
        colId: 'serialNumber',
        field: 'serialNumber',
        width: 100
      })*/
      return columnDefs
    },
    finalRowData() {
      return this.rowData.filter(p => !p.deleted)
    }
  },
  watch: {
    manifestInfo(newVal) {
      this.init()
    },
    isSeaHouseChannel(newVal) {
      this.gridOptions.api.refreshHeader()
    }
  },
  created() {
    this.init()
  },
  methods: {
    checkModels(tabName) {
      if (!this.rowData || this.rowData.length <= 0) return
      for (const item of this.rowData) {
        if (!item.deleted) {
          this.checkModel(item, tabName)
        }
      }
    },
    beforeUpload(file) {
      var fileType = file.name.substring(file.name.lastIndexOf('.') + 1)
      const extension = fileType === 'xls'
      const extension2 = fileType === 'xlsx'
      if (!extension && !extension2) {
        this.$message.warning(this.$t('SeaExport.FileOnlyXlsXlsx'))
      }
      return extension || extension2
    },
    uploadSuccess(response, file, fileList) {
      if (response && response.data) {
        this.saveImportData(response.data)
      } else {
        this.$message.warning(this.$t('SeaExport.ImportFailedContactAdministrator'))
      }
    },
    saveImportData(item) {
      const manifestInfo = this.manifestInfo
      const manifestGoods = manifestInfo.manifestGoods
      manifestGoods.push(...item.manifestGoods)
    },
    // 选中 勾选框或者其他列 都会触发[获取选中行]
    onGridCellFocused(event) {
      if (!event) return
      this.selectedRow = null
      if (this.gridApi && event.column) {
        this.gridApi.forEachNode(node => {
          if (node && node.rowIndex === event.rowIndex && node.data) {
            this.selectedRow = node.data
          }
        })
      }
    },
    onGridRowSelected(event) {
      if (!event || !event.data) return
      this.selectedRow = null
      if (event.node.isSelected()) {
        this.selectedRow = event.data
      }
    },
    // 行点击触发事件
    onRowClicked(event) {
      if (!event || !event.data) return
      this.selectedRow = event.data
    },
    onGridReady(params) {
      this.gridApi = params.api
    },
    init() {
      this.cargoEnglishNameCheck = null
      this.markCheck = null
      if (this.manifestInfo.uuid) {
        this.toQuery()
      } else {
        this.rowData = this.manifestInfo.manifestGoods || []
      }
    },
    async toQuery() {
      if (!this.manifestInfo.manifestGoods || this.manifestInfo.manifestGoods.length <= 0) {
        const manifestInfo = new ManifestInfo(this.manifestInfo)
        this.rowData = await manifestInfo.getManifestGoods()
      } else {
        this.rowData = this.manifestInfo.manifestGoods
      }
      if (this.specialCharacterCheck) {
        const cargoEnglishName = []
        const mark = []
        for (const item of this.finalRowData) {
          let texts = StrUtils.getSpecialTexts(item.cargoEnglishName)
          if (texts && texts.length > 0) {
            cargoEnglishName.push(...texts)
          }
          texts = StrUtils.getSpecialTexts(item.mark)
          if (texts && texts.length > 0) {
            mark.push(...texts)
          }
        }
        if (cargoEnglishName.length > 0) {
          this.cargoEnglishNameCheck = getHeaderComponentParamsWithWarning(this.$t('CargoMsg.SpecialCharactersExcept') + '：' + Array.from(cargoEnglishName, p => `&#34;${p}&#34;`).join('，'))
        } else {
          this.cargoEnglishNameCheck = null
        }
        if (mark.length > 0) {
          this.markCheck = getHeaderComponentParamsWithWarning(this.$t('CargoMsg.SpecialCharactersExcept') + '：' + Array.from(mark, p => `&#34;${p}&#34;`).join('，'))
        } else {
          this.markCheck = null
        }
      }
      this.fillModel()
    },
    showEditDialog(isNew, newRow) {
      if (isNew) {
        if (!newRow) {
          newRow = new ManifestGoodsInfo().fillDefaultValue().getData()
          newRow.weightUnit = 'KGS'
          newRow.cubageUnit = 'CBM'
        }
        newRow.manifestInfoUuid = this.manifestInfo.uuid
        newRow.serialNumber = PrePlanBookingUtil.getMaxSerialNumber(this.manifestInfo)
        this.editDialog.form = newRow
        this.editDialog.title = this.$t('common.btn.new')
      } else {
        if (!this.isEditing) { // 查看
          this.editDialog.form = newRow
          this.editDialog.title = this.$t('common.btn.look')
        } else {
          const row = this.selectedRow
          if (!row) { // 编辑
            this.$message.warning(this.$t('common.tips.hasOneAtleast'))
            return
          }
          if (!row.seq) {
            row.seq = this.autoIncrementNum.getNextNum()
          }
          this.editDialog.form = { ...row }
          this.editDialog.title = this.$t('common.btn.edit')
        }
      }
      this.editDialog.visible = true
    },
    showAdvanceTextDialog(title, value, successCallback) {
      this.advanceTextDialog.title = title
      this.advanceTextDialog.value = value
      this.advanceTextDialog.successCallback = successCallback
      this.advanceTextDialog.visible = true
    },
    finishAdvanceText() {
      const successCallback = this.advanceTextDialog.successCallback
      if (successCallback && typeof successCallback === 'function') {
        successCallback(this.advanceTextDialog.value)
      }
      this.advanceTextDialog.visible = false
    },
    fillModel() {
      if (!this.isOrNotDisplaySoNo && this.rowData && this.rowData.length > 0) {
        for (const item of this.rowData) {
          item.soNo = null // 加拼业务，货物信息关单号为null
        }
      }
    },
    checkModel(form, tabName) {
      if (!this.isAddSpelling && !form.soNo && this.isOrNotDisplaySoNo) {
        throw new ErrorTip(`【${this.$t('SeaExport.CargoInfo')}】${this.$t('SeaExport.TheNoCannotBeBlank')}`, tabName)
      }
      if (!form.containerNo) {
        throw new ErrorTip(`【${this.$t('SeaExport.CargoInfo')}】${this.$t('SeaExport.CaseNumberCannotBeEmpty')}`, tabName)
      }
      // 不做强制要求
      /* if (!ContainerNoHelper.checkContainerNo(form.containerNo)) {
        throw new ErrorTip(`【${this.$t('SeaExport.CargoInfo')}】${this.$t('SeaExport.InvalidCaseNumber')}`, tabName)
      }*/
      if (!form.sealNo) {
        throw new ErrorTip(`【${this.$t('SeaExport.CargoInfo')}】${this.$t('SeaExport.TheSealNumberCannotBeEmpty')}`, tabName)
      }
      if (!form.eqSize) {
        throw new ErrorTip(`【${this.$t('SeaExport.CargoInfo')}】${this.$t('SeaExport.BoxTypeCannotBeEmpty')}`, tabName)
      }
      if (!form.cargoEnglishName) {
        throw new ErrorTip(`【${this.$t('SeaExport.CargoInfo')}】${this.$t('SeaExport.EnglishNameCannotBeEmpty')}`, tabName)
      }
      if (!form.mark) {
        throw new ErrorTip(`【${this.$t('SeaExport.CargoInfo')}】${this.$t('SeaExport.TheMarkCannotBeEmpty')}`, tabName)
      }
      if (!form.hsCode && !this.isSeaHouseChannel) {
        throw new ErrorTip(`【${this.$t('SeaExport.CargoInfo')}】${this.$t('SeaExport.HscodeCannotBeEmpty')}`, tabName)
      }
      if (!form.packing) {
        throw new ErrorTip(`【${this.$t('SeaExport.CargoInfo')}】${this.$t('SeaExport.ThePackageCannotBeEmpty')}`, tabName)
      }
      if (!form.quantity || Number(form.quantity) <= 0) {
        throw new ErrorTip(`【${this.$t('SeaExport.CargoInfo')}】${this.$t('SeaExport.ThePiecesCannotBeEmpty')}`, tabName)
      }
      if (!form.weight || Number(form.weight) <= 0) {
        throw new ErrorTip(`【${this.$t('SeaExport.CargoInfo')}】${this.$t('SeaExport.GrossWeightCannotBeEmpty')}`, tabName)
      }
      if (!form.cubage || Number(form.cubage) <= 0) {
        throw new ErrorTip(`【${this.$t('SeaExport.CargoInfo')}】${this.$t('SeaExport.VolumeCannotBeEmpty')}`, tabName)
      }
      // 如果是海管家通道，且填了UN CODE,危险品等级，则需限制填写是否正确
      if (this.isSeaHouseChannel) {
        if (form.danUNNo) {
          if (!isNumber(form.danUNNo) || form.danUNNo.length !== 4) {
            throw new ErrorTip(`【${this.$t('SeaExport.CargoInfo')}】${this.$t('SeaExport.DanUNNoCannotBeEmpty')}`, tabName)
          }
        }
        if (form.danClassNo) {
          if (!isNumber(form.danClassNo) || !(Number(form.danClassNo) >= 1 && Number(form.danClassNo) <= 9.9)) {
            throw new ErrorTip(`【${this.$t('SeaExport.CargoInfo')}】${this.$t('SeaExport.DanClassNoCannotBeEmpty')}`, tabName)
          }
        }
      }
      // 如果货物类型是危险品，则需要校验【危险品联系人】【危险品联系人电话】字段必填。
      if ((this.showCombinedManifest && this.manifestInfo.cargoType === 'DG') || (this.manifestInfo.thirdPartyCargoType === 'DR' && this.isSeaHouseChannel)) {
        if (StrUtils.isEmpty(form.dngrContactUser)) {
          throw new ErrorTip(`【${this.$t('SeaExport.CargoInfo')}】${this.$t('SeaExport.DangerousGoodsContactCannotBeEmpty')}`, tabName)
        }
        if (StrUtils.isEmpty(form.dngrContactNumber)) {
          throw new ErrorTip(`【${this.$t('SeaExport.CargoInfo')}】${this.$t('SeaExport.DangerousGoodsContactPhoneNumberCannotBeEmpty')}`, tabName)
        }
      }
    },
    save() {
      const form = this.editDialog.form
      const tabName = 'tabPrePlanBooking'
      this.checkModel(form, tabName)
      if (!form.seq) {
        this.rowData.push(form)
      } else {
        const row = this.rowData.find(p => p.seq === form.seq)
        if (row) {
          Object.assign(row, form)
          this.gridApi.refreshCells({ force: true })
        }
      }
      // this.$message.success(this.$t('common.tips.saveSuccess'))
      this.editDialog.visible = false
    },
    remove() {
      const rows = this.gridApi.getSelectedRows()
      if (rows && rows.length === 0) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      // this.$confirm(this.$t('common.tips.confirmDelete'), this.$t('common.tips.prompt'), {
      //   confirmButtonText: this.$t('common.btn.ok'),
      //   cancelButtonText: this.$t('common.btn.cancel'),
      //   type: 'warning'
      // }).then(() => {
      if (this.rowData) {
        for (let i = this.rowData.length - 1; i >= 0; --i) {
          const row = this.rowData[i]
          if (rows.includes(row)) {
            if (row.uuid) {
              row.deleted = true
            } else {
              this.rowData.splice(i, 1)
            }
          }
        }
      }
      const tempRowData = this.rowData
      this.rowData = []
      this.$nextTick(() => {
        this.rowData = tempRowData
      })
      // this.$message.success(this.$t('common.tips.deleteSuccess'))
    //   }).catch(() => { })
    },
    // 从装箱信息导入
    async importFromContainer() {
      const job = new SeaExportJob(this.job)
      const containerUsages = await this.getContainerUsages(job)
      if (containerUsages && containerUsages.length > 0) {
        const newManifestGoodsInfos = await PrePlanBookingUtil.syncContainer(containerUsages, this.rowData, job, this.manifestInfo, this.isSeaHouseChannel)
        this.rowData = newManifestGoodsInfos
        if (job.lclSlaves.length > 0) {
          for (const slaves of job.lclSlaves) {
            const Jobslaves = new SeaExportJob(slaves)
            const result = await Jobslaves.getSpecialGoods()
            if (result.length > 0) {
              this.rowData.forEach((item) => {
                if (item.jobUuid === result[0].jobUuid) {
                  item.danUNNo = result[0].danUNNo
                  item.danClassNo = result[0].danClassNo
                }
              })
            }
          }
        } else {
          const singleData = await job.getSpecialGoods()
          this.rowData.forEach((item) => {
            if (item.jobUuid === singleData[0].jobUuid) {
              item.danUNNo = singleData[0].danUNNo
              item.danClassNo = singleData[0].danClassNo
            }
          })
        }
        this.gridApi.refreshCells({ force: true })
      } else {
        this.$message.info(this.$t('SeaExport.TherePleaseEnterItTab'))
      }
    },
    // 同步更新装箱信息
    synchronizePackingInfo() {
      if (!this.manifestInfo.uuid) {
        this.$message.warning(this.$t('SeaExport.ManifestDataIsEmpty'))
        return
      }
      if (!this.manifestInfo.manifestGoods || this.manifestInfo.manifestGoods.length === 0) {
        this.$message.warning(this.$t('SeaExport.CargoInformationIsEmpty'))
        return
      }
      if (this.vgmRequiredInput && (!this.manifestInfo.manifestVGMs || this.manifestInfo.manifestVGMs.length === 0)) {
        this.$message.warning(this.$t('SeaExport.VGMIsEmpty'))
        return
      }
      if (this.manifestInfo.cfmState !== ManifestCfmState.CFM_STATE_DONE.code) {
        this.$message.warning(this.$t('SeaExport.ManifestNotConfirmed'))
        return
      }
      // 判断箱型箱种
      if (!this.job.seaEQ) {
        this.$message.warning(this.$t('SeaExport.NoDataSynced'))
        return
      }
      let eqFlag = false
      for (const item of this.manifestInfo.manifestGoods) {
        for (const eq of this.job.seaEQ) {
          if (item.eqSize === eq.eqSize + eq.eqType || (['40HQ', '40HC'].indexOf(item.eqSize) > -1 && ['40HQ', '40HC'].indexOf(eq.eqSize + eq.eqType) > -1)) {
            eqFlag = true
            break
          }
        }
        if (eqFlag) {
          break
        }
      }
      if (!eqFlag) {
        this.$message.warning(this.$t('SeaExport.NoDataSynced'))
        return
      }
      const self = this
      self.loading = getLoading()
      synchronousManifest({
        manifestInfoUuid: this.manifestInfo.uuid,
        branchId: this.$store.getters.currentOfficeId
      }).then(res => {
        this.$emit('reload')
        this.$message.success(this.$t('Message.SynchronizationSucceeded'))
      }).catch().finally(() => {
        self.loading.close()
      })
    },
    // 确认
    async cfmBtnClickHandlers() {
      if (!this.manifestInfo.uuid) {
        this.$message.warning(this.$t('SeaExport.ManifestDataIsEmpty'))
        return
      }
      if (!this.manifestInfo.manifestGoods || this.manifestInfo.manifestGoods.length === 0) {
        this.$message.warning(this.$t('SeaExport.CargoInformationIsEmpty'))
        return
      }
      if (this.vgmRequiredInput && (!this.manifestInfo.manifestVGMs || this.manifestInfo.manifestVGMs.length === 0)) {
        this.$message.warning(this.$t('SeaExport.VGMIsEmpty'))
        return
      }
      const self = this
      self.loading = getLoading()
      confirmManifest({
        manifestInfoUuid: this.manifestInfo.uuid,
        branchId: this.$store.getters.currentOfficeId
      }).then(res => {
        this.$emit('reload')
        this.$message.success(this.$t('SeaExport.ManifestConfirmed'))
      }).catch().finally(() => {
        self.loading.close()
      })
    },
    async getContainerUsages(job) {
      // 如果是主票
      const masterContainerUsages = []
      if (job.masterFlag) {
        const containers = await job.getContainers()
        if (containers && containers.length > 0) {
          for (const container of containers) {
            if (container.containerUsage && container.containerUsage.length > 0) {
              for (const usage of container.containerUsage) {
                const tempUsage = deepClone(usage)
                tempUsage.container = container
                masterContainerUsages.push(tempUsage)
              }
            }
          }
        }
        return masterContainerUsages
      }
      // 非主票
      return await job.getContainerUsages()
    },
    // 从主票导入
    importFromLcLContainer() {
      if (!this.job.lclMasterUuid) {
        this.$message.info(this.$t('SeaExport.NoMasterTicketInformationYet'))
        return
      }
      // ManifestInfo.synchronizationGoodsInfoByX(manifestInfo.job.key, importSuccessHandler, faultHandler)
    },
    // 复制/查看
    copyAndAddItem(params) {
      const source = params.data
      if (!this.isEditing) { // 查看
        this.showEditDialog(false, source)
        return
      }
      const newRow = new ManifestGoodsInfo().fillDefaultValue().getData()
      newRow.soNo = source.soNo
      newRow.containerNo = source.containerNo
      newRow.sealNo = source.sealNo
      newRow.eqSize = source.eqSize
      newRow.cargoEnglishName = source.cargoEnglishName
      newRow.mark = source.mark
      newRow.hsCode = source.hsCode
      newRow.packing = source.packing
      newRow.quantity = source.quantity
      newRow.weight = source.weight
      newRow.cubage = source.cubage
      newRow.weightUnit = source.weightUnit
      newRow.cubageUnit = source.cubageUnit
      newRow.danUNNo = source.danUNNo
      newRow.danClassNo = source.danClassNo
      this.showEditDialog(true, newRow)
    },
    containerNbrStyleFunction(data) {
      if (!ContainerNoHelper.checkContainerNo(data.containerNo)) {
        return { color: '#F56C6C' }
      }
      return ''
    },
    hsCodeNbrStyleFunction(data) {
      if (data.hsCode && data.hsCode.length <= 5) {
        return { color: '#F56C6C' }
      }
      return ''
    },
    copy() {
      const rows = this.gridApi.getSelectedRows()
      if (!rows || rows.length === 0) {
        this.$message.warning(this.$t('SeaExport.ChooseSoNoInfoToCopy'))
        return
      }
      // 添加勾选数据
      for (const row of rows) {
        const newRow = new ManifestGoodsInfo().fillDefaultValue().getData()
        commonUtil.objCopy(row, newRow)
        // 初始化 状态数据
        newRow.uuid = ''
        newRow.ediStatus = 0
        newRow.manifestId = null
        newRow.seaHouseState = '-1'
        newRow.changeState = 0
        this.rowData.push(newRow)
      }
    },
    getSoNoList(getSoNoList) {
      // CARGO-39659 锦昶不需要同步关单号的逻辑，但是不加getSoNoList这个方法会报错
    },
    // 转大写并去除空格
    toUpperCaseTrim(val) {
      return val.toUpperCase().trim()
    },
    checkGoodsRemark(val) {
      if (!val) {
        this.editDialog.form.goodsRemark = ''
        return
      }
      const allowedPattern = /^[!"#%&'()*+,\-./:;<=>?@_0-9a-zA-Z\s\n]*$/
      if (val.length > 3999 || !allowedPattern.test(val)) {
        this.$message.warning(this.$t('CargoMsg.Cargo_Remark_Check'))
        return
      }
      this.editDialog.form.goodsRemark = val
    }
    /*,
    containerNbrChange() {
      this.containerNoClass = this.containerNbrStyleFunction({ containerNo: this.editDialog.form.containerNo })
    }*/
  }
}
</script>

<style lang='scss'>
  .booking-manifest-goods-info{
    .data-red {
      color: #FF0000;
    }
    .required-label .ag-header-cell-text{
      color: #1F75D5 !important;
    }
  }
</style>
